// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__WGh+W","burger-opened":"Burger_burger-opened__iWoie","burger-bar":"Burger_burger-bar__PyNbC"};